import axios from 'axios';

const axiosConfig = axios.create({
    baseURL: process.env.REACT_APP_MERCHANT_API
});

// Use an interceptor to ensure the token is always fresh and included in every request
axiosConfig.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('userToken');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

axiosConfig.defaults.headers.post['Content-Type'] = 'application/json;charset=utf-8';

export default axiosConfig;